import ideaCardBack from 'assets/image/ideation/idea_car_back.svg';
import blob from 'assets/image/ideation/convocation_blob_back.svg';

import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
	root: {
		maxWidth: 1144,
		width: '100%',
	},
	//convocation list==================================================================================================
	ideaHeader: {
		padding: '20px 0',
		marginTop: 40,
		justifyContent: 'space-between',
		[theme.breakpoints?.down('md')]: {
			marginTop: 10,
			justifyContent: 'center',
			flexDirection: 'column-reverse',
		},
	},
	titleContainer: {
		width: 'fit-content',
		[theme.breakpoints?.down('md')]: {
			width: '100%',
			'& img': {
				maxWidth: 120,
			},
		},
	},

	containedIdeaBtn: {
		color: '#fff',
		height: 40,
		borderRadius: 70,
		backgroundColor: '#24C1A8',
		border: '2px solid #fff',
		whiteSpace: 'nowrap',
		boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.3)',
		flex: 1,
		'&:hover': {
			backgroundColor: '#188977',
		},
	},
	containedIdeaBtn2: {
		color: '#fff',
		border: '2px solid #fff',
		height: 40,
		borderRadius: 70,
		whiteSpace: 'nowrap',
		backgroundColor: '#24C1A8',
		width: 160,
		boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.3)',
		'&:hover': {
			backgroundColor: '#188977',
			boxShadow: 'none',
		},
		'&:disabled': {
			backgroundColor: '#eee',
		},
		[theme.breakpoints?.down('md')]: {},
	},
	containedIdeaBtn3: {
		color: '#fff',
		border: '2px solid #fff',
		height: 40,
		borderRadius: 70,
		whiteSpace: 'nowrap',
		backgroundColor: '#CB1C68',
		flex: 1,
		boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.3)',
		'&:hover': {
			backgroundColor: '#188977',
			boxShadow: 'none',
		},
		'&:disabled': {
			backgroundColor: '#eee',
		},
		[theme.breakpoints?.down('md')]: {},
	},
	containedIdeaBtn4: {
		color: '#fff',
		border: '2px solid #fff',
		height: 40,
		borderRadius: 70,
		whiteSpace: 'nowrap',
		backgroundColor: '#24C1A8',

		boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.3)',
		'&:hover': {
			backgroundColor: '#188977',
			boxShadow: 'none',
		},
		'&:disabled': {
			backgroundColor: '#eee',
		},
		[theme.breakpoints?.down('md')]: {},
	},
	containedIdeaBtn5: {
		color: '#fff',
		border: '2px solid #fff',
		height: 40,
		borderRadius: 70,
		whiteSpace: 'nowrap',
		backgroundColor: '#EF9825',
		padding: '0 40px',
		boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.3)',
		'&:hover': {
			backgroundColor: '#188977',
			boxShadow: 'none',
		},
		'&:disabled': {
			backgroundColor: '#eee',
		},
		[theme.breakpoints?.down('md')]: {},
	},
	containedIdeaBtn6: {
		color: '#fff',
		border: '2px solid #fff',
		height: 40,
		borderRadius: 70,
		whiteSpace: 'nowrap',
		backgroundColor: '#EE1E3A',

		boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.3)',
		'&:hover': {
			backgroundColor: '#a92436',
			boxShadow: 'none',
		},
		'&:disabled': {
			backgroundColor: '#eee',
		},
		[theme.breakpoints?.down('md')]: {},
	},
	containedIdeaBtn7: {
		color: '#fff',

		height: 40,
		borderRadius: 16,
		whiteSpace: 'nowrap',
		backgroundColor: '#FA9089',

		boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.3)',
		'&:hover': {
			backgroundColor: '#d74b41',
			boxShadow: 'none',
		},
		'&:disabled': {
			backgroundColor: '#eee',
		},
		[theme.breakpoints?.down('md')]: {},
	},
	containedIdeaBtn8: {
		color: '#fff',
		height: 40,
		borderRadius: 16,
		backgroundColor: '#24C1A8',
		whiteSpace: 'nowrap',

		boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.3)',
		'&:hover': {
			backgroundColor: '#188977',
			boxShadow: 'none',
		},
		'&:disabled': {
			backgroundColor: '#eee',
		},
		[theme.breakpoints?.down('md')]: {},
	},
	containedIdeaBtn9: {
		color: '#fff',
		height: 40,
		borderRadius: 16,
		backgroundColor: '#427FF0',
		whiteSpace: 'nowrap',

		boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.3)',
		'&:hover': {
			backgroundColor: '#2658b4',
			boxShadow: 'none',
		},
		'&:disabled': {
			backgroundColor: '#eee',
		},
		[theme.breakpoints?.down('md')]: {},
	},
	containedIdeaBtn10: {
		backgroundColor: '#24C1A8',
		color: '#fff',
		boxShadow: ' 0px 4px 10px rgba(0, 0, 0, 0.25)',
		borderRadius: 16,
		fontSize: 16,
		fontWeight: 'bold',
		cursor: 'default',
		'&:hover': {
			backgroundColor: '#24C1A8',
		},
	},
	containedIdeaBtn11: {
		backgroundColor: '#fff',
		boxShadow: ' 0px 4px 10px rgba(0, 0, 0, 0.25)',
		borderRadius: 16,
		fontSize: 16,
		fontWeight: 'bold',
	},
	lampChargeRed2: {
		width: 40,
	},
	backGroundPatternContainer: {
		position: 'relative',
		marginBottom: 30,
		minHeight: 421,
		backgroundImage: `url(${ideaCardBack})`,
		backgroundRepeat: 'space',
		backgroundSize: '27%',
		backgroundPosition: 'center',
	},
	outlinedIdeaBtn2: {
		height: 40,
		borderRadius: 70,
		borderColor: '#24C1A8',
		color: '#24C1A8',
		backgroundColor: '#fff',
		width: 160,
		boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.3)',
		'&:hover': {
			boxShadow: 'none',
		},
		[theme.breakpoints?.down('md')]: {},
	},
	convocationAvatar: {
		flex: 1,
		maxWidth: 570,
		[theme.breakpoints?.down('md')]: {
			maxWidth: '90%',
			marginTop: 20,
		},
	},
	convocationAvatar2: {
		flex: 1,
		maxWidth: '55%',
		[theme.breakpoints?.down('md')]: {
			maxWidth: '90%',
			marginTop: 20,
		},
	},
	blobBack: {
		position: 'absolute',
		width: '600px',
		right: 55,
		bottom: -120,
	},
	//add convocation =================================================================================================
	addActivityContainer: {
		maxWidth: 900,
		marginTop: 85,
		userSelect: 'none',
		[theme.breakpoints.down('sm')]: {
			padding: 10,
			margin: 0,
		},
	},
	roleAndTitleContainer: {
		flexWrap: 'nowrap',
		marginBottom: 62,
		paddingRight: '16px',
		[theme.breakpoints.down('sm')]: {
			flexWrap: 'wrap',
			flexDirection: 'column !important',
			marginBottom: 12,
		},
	},
	roleContainer: {
		maxWidth: 350,
		[theme.breakpoints.down('sm')]: {
			maxWidth: '100%',
			width: '100%',
			marginTop: 30,
		},
	},
	star: {
		color: '#d50a0a',
		fontSize: 18,
		fontWeight: 'bold',
		paddingRight: '10px',
		paddingLeft: '4px',
		position: 'relative',
		top: 3,
	},
	star2: {
		color: '#d50a0a',
		fontSize: 18,
		fontWeight: 'bold',
		padding: '0 5px',
		position: 'relative',
		top: 3,
	},
	fieldTitleContainer: {
		display: 'flex',
		flexWrap: 'nowrap',

		[theme.breakpoints.down('sm')]: {
			'& h6': {
				whiteSpace: 'nowrap',
			},
		},
	},
	uploadContainer: {
		position: 'relative',
		[theme.breakpoints.down('sm')]: {
			paddingTop: 20,
		},
	},
	grid: {
		flexDirection: 'column',
		padding: '0 15px',

		marginBottom: 25,
		[theme.breakpoints.down('sm')]: {
			padding: 0,
			marginBottom: 12,
		},
	},
	dateDialog: {
		'& .MuiDialog-paper': {
			'& .MuiPickersToolbar-toolbar': {
				backgroundImage: 'linear-gradient(to right ,#0ebca0,#1978ba)',
				'& .MuiButton-label h6': {
					fontSize: 22,
				},
			},
		},
	},
	modalGridContainer: {
		padding: '45px',
		backgroundColor: '#fff',
		width: 500,
		height: 320,
		borderRadius: 35,
		boxShadow:
			'0px 11px 15px -7px rgba(0,0,0,0.2), 0px 24px 38px 3px rgba(0,0,0,0.14), 0px 9px 46px 8px rgba(0,0,0,0.12)',
	},
	modalGridContainer2: {
		padding: '25px',
		backgroundColor: '#fff',
		width: 980,
		borderRadius: 35,

		boxShadow:
			'0px 11px 15px -7px rgba(0,0,0,0.2), 0px 24px 38px 3px rgba(0,0,0,0.14), 0px 9px 46px 8px rgba(0,0,0,0.12)',
	},
	modalGridContainer3: {
		borderRadius: 35,
		padding: '60px ',
		backgroundColor: '#fff',
		minWidth: 550,
		minHeight: 290,
		boxShadow:
			'0px 11px 15px -7px rgba(0,0,0,0.2), 0px 24px 38px 3px rgba(0,0,0,0.14), 0px 9px 46px 8px rgba(0,0,0,0.12)',
	},
	registerScoreBtn: {
		borderRadius: 30,
		border: '',
	},
	paperModal2: {
		borderRadius: 30,
		position: 'relative',
		backgroundColor: 'transparent',
		padding: '18px',
		boxShadow: 'none',
		overflow: 'visible',
	},
	path: {
		position: 'absolute',
		top: -2,
		left: 0,
		zIndex: 1,
	},
	path2: {
		position: 'absolute',
		bottom: -2,
		right: 0,
		transform: 'rotate(180deg)',
		zIndex: 1,
	},
	addMentorVector: {
		[theme.breakpoints?.down('sm')]: {
			display: 'none',
		},
	},
	convocationInfoDetail: {
		backgroundImage: `url(${blob})`,
		backgroundSize: 'cover',
		backgroundPosition: 'center',
	},
	infoContainer1: {
		width: 'fit-content',
		[theme.breakpoints?.down('sm')]: {
			width: '48%',
			flexWrap: 'nowrap',
			marginBottom: 10,
		},
	},
	infoIcon1: {
		borderRadius: '16px 0 0 16px ',
		backgroundColor: '#CB1C68',
		width: 50,
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
		boxShadow: '0px 7px 15px rgba(0, 0, 0, 0.15)',
	},
	info1: {
		border: '1px solid #A2A2A2',
		boxShadow: '0px 7px 15px rgba(0, 0, 0, 0.15)',
		borderRadius: '0 16px 16px 0',
		marginLeft: 8,
		width: 200,
		padding: '12px 0',
		fontWeight: 'bold',
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
		background: '#fff',
	},
	registerIdeaContainer: {
		background: 'linear-gradient(269.82deg, #20DACD -10.37%, #3490B8 107.46%)',
		position: 'relative',
		padding: '30px 20px',
		marginTop: 70,
	},
	registerIdeaDesc: {
		color: '#fff',
		fontSize: 18,
		[theme.breakpoints?.down('sm')]: {
			margin: '20px 0',
			fontSize: 18,
			textAlign: 'center',
			fontWeight: 'bold',
			lineHeight: 2.3,
		},
	},
	registerIdeaBtnContainer: {
		width: 'fit-content',
		[theme.breakpoints?.down('sm')]: {
			width: '100%',
			justifyContent: 'center',
		},
	},
	lumpChargeImgContainer: {
		background: '#fff',
		borderRadius: '100%',
		padding: '10px 14px',
		position: 'absolute',
		left: '47%',
		top: -30,
	},
	lumpChargeImg: {
		width: 35,
	},
	registerIdeaText: {
		fontSize: 22,
		fontWeight: 'bold',
		[theme.breakpoints?.down('sm')]: {
			fontSize: 18,
		},
	},
	registerIdeaBtn: {
		width: 200,
		display: 'flex',
		justifyContent: 'space-between',
		alignItems: 'center',
		backgroundColor: '#fff',
		padding: '6px 12px',
		border: '2px solid #CB1C68',
		borderRadius: 30,
	},
	arrowLeft: {
		width: 28,
	},
	ideaBoxContainer: {
		flexWrap: 'nowrap',
		[theme.breakpoints?.down('sm')]: {
			flexDirection: 'column',
			alignItems: 'center',
		},
	},
	ideaBoxTitle: {
		margin: '20px 0 0 0',
		padding: 20,
		borderRadius: 16,
		gap: 40,
		boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.25)',
		[theme.breakpoints?.down('sm')]: {
			width: 'fit-content',
			gap: 20,
		},
	},
	ideaBoxTitle2: {
		margin: '20px 0 0 0',
		padding: 20,
		borderRadius: 16,
		gap: 40,
		boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.25)',
		[theme.breakpoints?.down('sm')]: {
			flexWrap: 'nowrap',
			overflow: 'auto',
			marginTop: 0,
		},
	},
	ideaFilter: {
		fontWeight: 'bold',
		fontSize: 14,
		cursor: 'pointer',
		[theme.breakpoints?.down('sm')]: {
			whiteSpace: 'nowrap',
		},
	},
	activeIdeaFilter: {
		fontWeight: 'bold',
		fontSize: 14,
		color: '#20DACD',
		[theme.breakpoints?.down('sm')]: {
			whiteSpace: 'nowrap',
		},
	},
	textarea: {
		width: '100%',
		height: 200,
		userSelect: 'none',
		fontSize: 15,
		borderRadius: 5,
		boxShadow: '0 3px 31px 0 rgba(0, 0, 0, 0.15)',
		padding: '3px 15px',
		border: 'none',
		fontFamily: 'iranSans',
		backgroundColor: '#fff',
		resize: 'none',
		'&:focus': {
			outline: 'none',
		},
		marginTop: 10,
	},
	yellowBtn: {
		color: '#000',
		fontWeight: '700',
		marginTop: 30,
		backgroundColor: '#ffd200',
		fontSize: 18,
		boxShadow: '0 3px 42px 0 #d0ad0b',
		'&:hover': {
			backgroundColor: '#ffd200',
		},
	},
	addActivityButton: {
		backgroundColor: '#0ca160',
		color: '#fff',
		minWidth: 80,
		minHeight: 38,
		fontWeight: 'bold',
		boxShadow: '0 3px 42px 0 rgba(12, 161, 96, 0.47)',
		borderRadius: 20,
		'&:hover': {
			backgroundColor: '#1f704c',
		},
	},
	addActivityButtonDisabled: {
		width: 80,
		height: 38,
		borderRadius: 20,
	},
	padding30: {
		padding: 30,
	},
	selectFile: {
		borderRadius: 20,
		padding: '8px 15px',
		backgroundColor: '#f64366',
		color: '#fff',
		fontSize: 18,
		display: 'flex',
		justifyContent: 'center',
		cursor: 'pointer',
	},
	fileInput: {
		position: 'absolute',
		top: 13,
		height: 50,
		width: 120,
		visibility: 'hidden',
		cursor: 'pointer',
	},
	saveImageContainer: {
		padding: '0 30px',
	},
	saveImageInsideContainer: {
		backgroundColor: '#fff',
		boxShadow: ' 0 6px 12px 0 rgba(0, 0, 0, 0.05)',
		height: 60,
		padding: '0 25px',
		marginTop: 6,
	},
	saveImage: {
		backgroundColor: '#ebebeb',
		borderRadius: 30,
		height: 40,
		boxShadow: 'none',
	},
	divider: {
		height: 1,
		backgroundColor: '#a6a6a6',
		margin: '35px 0px',
	},
	imageSectionContainer: {
		padding: '0 30px',
		minHeight: 122,
	},
	documentContainer: {
		paddingBottom: 10,
		borderBottom: '1px dashed #d0d0d0',
		marginTop: 10,
	},
	primaryBtn: {
		backgroundColor: theme.palette.primary.main,
		color: '#fff',
		padding: '5px 15px',
		borderRadius: 5,
	},
	cancelBtn: {
		backgroundColor: 'rgb(25 120 186 / 10%)',
		padding: '5px 20px',
		borderRadius: '5px',
	},
	documentBoxContainer: {
		minHeight: 150,
	},
	documentItemContainer: {
		padding: '10px 20px',
		backgroundColor: '#ffff',
		borderRadius: 8,
		marginTop: 10,
	},
	documentTitle: {
		width: 260,
		maxWidth: 260,
		display: 'flex',
		justifyContent: 'flex-end',
		alignItems: 'center',
		whiteSpace: 'nowrap',
		overflow: 'hidden',
		textOverflow: 'ellipsis',
	},
	removeContainer: {
		width: 260,
	},
	removeDocIcon: {
		color: '#f64366',
	},
	//detail convocation ========================================================================================
	introductionContainer: {
		marginBottom: 40,
		borderRadius: 16,
		overflow: 'hidden',
		flexWrap: 'nowrap',
		border: '1px solid #24C1A8',
		[theme.breakpoints?.down('sm')]: {
			marginBottom: 10,
			flexWrap: 'wrap',
			height: 'fit-content',
			border: 'none',
		},
	},
	detailHeaderContainer: {
		flexWrap: 'nowrap',
		marginBottom: 20,
		gap: 10,
		[theme.breakpoints?.down('md')]: {
			display: 'flex',
			flexWrap: 'wrap',
			flexDirection: 'column',
			gap: 30,
		},
	},
	convocationDetailHeaderContainer: {
		[theme.breakpoints?.down('md')]: {
			justifyContent: 'center',
		},
	},
	roundedActiveBorder: {
		width: '100%',
		border: '1px solid #CB1C68',
		borderRadius: 10,
		padding: '3px 10px',
		position: 'relative',
		paddingLeft: 60,
		boxShadow: '0px 7px 15px rgba(0, 0, 0, 0.15)',
		[theme.breakpoints?.down('md')]: {
			padding: '10px',
		},
	},
	borderedIcon: {
		width: '40px',
		height: '40px',
		border: '1px solid #CB1C68',
		borderRadius: '100%',
		padding: '4px',
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
		backgroundColor: '#fff',
		position: 'absolute',
		left: 7,
		top: -15,
	},
	introductionSelectedTabsContainer: {
		width: 'fit-content',
		borderRight: '1px solid #24C1A8',
		[theme.breakpoints?.down('sm')]: {
			width: '100%',
			border: 'none',
		},
	},
	borderYDetail: {
		border: '1px solid #24C1A8',
		borderLeft: 'none',
		borderRight: 'none',
		[theme.breakpoints?.down('sm')]: {
			border: 'none',
		},
	},
	borderBottomDetail: {
		borderBottom: '1px solid #24C1A8',
		[theme.breakpoints?.down('sm')]: {
			border: 'none',
		},
	},
	introductionSelectedTabs: {
		width: '200px',
		height: 'fit-content',
		backgroundColor: '#fff',
		[theme.breakpoints?.down('sm')]: {
			width: '100%',
			flexDirection: 'row',
			flexWrap: 'nowrap',
			overflow: 'auto',
			gap: 16,
			padding: '10px',
		},
	},
	introductionShowTabsContainer: {
		paddingLeft: 20,
		minHeight: '100%',
		overflow: 'hidden',
		[theme.breakpoints?.down('sm')]: {
			paddingLeft: 0,
			minHeight: '100px',
			marginTop: 12,
			width: '100%',
		},
	},
	blobBackAdd: {
		width: '100%',
	},
	introResultBoxContainer: {
		backgroundColor: '#fff',
		padding: '20px',
		borderRadius: '10px',
		[theme.breakpoints?.down('sm')]: {
			padding: '5px',
		},
	},
	adminBoxDetail: {
		overflow: 'auto',
		maxHeight: 194,
		paddingLeft: 10,
		[theme.breakpoints?.down('sm')]: {
			maxHeight: 500,
			border: '1px solid #24C1A8',
			padding: 10,
			borderRadius: 16,
		},
	},

	normalBox: {
		overflow: 'auto',
		maxHeight: 137,
		paddingLeft: 10,
		[theme.breakpoints?.down('sm')]: {
			maxHeight: 500,
			border: '1px solid #24C1A8',
			padding: 10,
			borderRadius: 16,
		},
	},
	introductionActiveTab: {
		padding: '20px 0px 20px 20px',
		fontWeight: 'bold',
		backgroundColor: '#24C1A8',
		color: '#fff',
		[theme.breakpoints?.down('sm')]: {
			borderRadius: 16,
			whiteSpace: 'nowrap',
			padding: '10px 20px',
		},
	},
	introductionTab: {
		padding: '20px 0px 20px 20px',
		fontWeight: 'bold',
		cursor: 'pointer',
		[theme.breakpoints?.down('sm')]: {
			borderRadius: 16,
			border: '1px solid #24C1A8',
			whiteSpace: 'nowrap',
			padding: '10px 20px',
		},
	},
	addBtn: {
		width: 120,
		borderRadius: 10,
		marginLeft: 10,
		color: '#fff',
		backgroundColor: '#23cc23',
		'&:hover': {
			backgroundColor: '#199b19',
		},
	},
	table: {
		'& th': {
			padding: '5px ',
			backgroundColor: '#eee',
		},
	},
	addIdeaTitleContainer: {
		marginBottom: 30,
		position: 'relative',
	},
	ideaTitleBack: {
		maxWidth: '100%',
	},
	ideaTitle: {
		width: 250,
		position: 'absolute',
		top: '25%',
	},
	//detail idea==========================================================================================
	input: {
		backgroundColor: '#e9e9e9',
		borderRadius: 10,
		border: 'none',
		width: '300px',
		fontFamily: 'iranSans',
		'&:focus': {
			outline: 'none',
		},
		'&::placeholder': {
			fontFamily: 'iranSans',
		},
		padding: '10px',
	},
	rootContainer: {
		padding: '30px',
		border: '2px solid #A2A2A2',
		position: 'relative',
		borderRadius: 16,
		[theme.breakpoints?.down('sm')]: {
			width: '90%',
			margin: 'auto',
			padding: '16px',
		},
	},
	blackPathTop: {
		position: 'absolute',
		top: -21,
		left: -25,
		[theme.breakpoints?.down('sm')]: {
			width: 60,
			top: -11,
			left: -10,
		},
	},
	blackPathBottom: {
		position: 'absolute',
		bottom: -21,
		right: -25,
		transform: 'rotate(180deg)',
		[theme.breakpoints?.down('sm')]: {
			width: 60,
			bottom: -11,
			right: -10,
		},
	},
	mentoringBtsContainer: {
		marginTop: 20,
		gap: 10,
	},
	ideaDescription: {
		marginTop: 30,
		marginBottom: 30,
	},
	goalDescription: {
		marginTop: 10,
		marginBottom: 30,
	},
	ideaDetailRowContainer: {
		gap: 30,
		[theme.breakpoints.down('sm')]: {
			gap: 10,
		},
	},
	ideaDetailShadowBox: {
		width: 'fit-content',
		border: '1px solid #A2A2A2',
		borderRadius: 16,
		padding: '6px 10px',
		boxShadow: '0px 7px 15px rgba(0, 0, 0, 0.15)',
		flex: 1,
		gap: 10,
		[theme.breakpoints.down('sm')]: {
			flex: 'unset',
			width: '100%',
			marginTop: 10,
		},
	},
	//comments
	sendCommentBox: {
		height: 60,
		marginTop: 10,
		backgroundColor: '#e3e3e3',
		borderRadius: 30,
		position: 'relative',
		paddingLeft: 10,
	},
	sendCommentIcon: {
		position: 'absolute',
		top: -4,
		cursor: 'pointer',
		right: 0,
	},
	commentUserName: {
		color: '#4a4a4a',
		fontWeight: 'bold',
		fontSizeL: 14,
	},
	commentBody: {
		fontSize: 16,
		color: '#2a2a2a',
		marginTop: 5,
		wordBreak: 'break-word',
	},
	dot: {
		width: 5,
		height: 5,
		borderRadius: '50%',
		backgroundColor: '#313237db',
		margin: '0 3px',
	},
	messageInput: {
		borderRadius: 30,
		width: 'calc(100% - 75px)',
		height: 42,
		backgroundColor: '#fff',
		border: 'none',
		paddingLeft: 15,
		paddingRight: 39,
		fontFamily: 'iranSans',
		fontSize: 14,
		'&:focus': {
			outline: 'none',
		},
		'&::placeholder': {
			fontFamily: 'iranSans',
			color: '#afabab',
			fontWeight: 'bold',
		},
	},
	mobileMessageInput: {
		borderRadius: 30,
		width: 'calc(100% - 55px)',
		height: 33,
		backgroundColor: '#fff',
		border: 'none',
		paddingLeft: 15,
		paddingRight: 39,
		fontFamily: 'iranSans',
		fontSize: 14,
		'&:focus': {
			outline: 'none',
		},
		'&::placeholder': {
			fontFamily: 'iranSans',
			color: '#afabab',
			fontWeight: 'bold',
		},
	},
	messageBoxContainer: {
		backgroundColor: '#f6f6f6',
		marginTop: 11,
		marginBottom: 40,
		borderRadius: 30,
		padding: 23,
	},
	messageItem: {
		backgroundColor: '#fff',
		borderRadius: 15,
		marginBottom: 5,
		padding: 17,
		marginTop: 20,
		[theme.breakpoints.down('sm')]: {
			marginTop: 20,
		},
	},
	responsiveItem: {
		backgroundColor: '#ebebeb',
		width: '90%',
		borderRadius: 15,
		marginBottom: 5,
		padding: 17,
		position: 'relative',
	},
	fitContent: {
		width: 'fit-content',
	},
	moreContainer: {
		marginRight: 15,
		cursor: 'pointer',
		padding: 10,
		width: '57px',
		position: 'relative',
		[theme.breakpoints?.down('sm')]: {
			position: 'absolute',
			top: 7,
			left: 12,
		},
	},
	viewContainer: {
		width: 'fit-content',
		marginRight: 10,
		[theme.breakpoints?.down('sm')]: {
			position: 'absolute',
			top: 45,
			left: 22,
			zIndex: 10,
			backgroundColor: 'rgba(139, 139, 139, 0.6)',
			borderRadius: '20px',
			padding: '0 5px ',
			'& *': {
				color: '#fff',
			},
		},
	},
	myDataBox: {
		position: 'relative',
		padding: '30px',
		borderRadius: 16,
		border: '1px solid #20DACD',
		gap: 20,
		marginTop: 100,
		height: 'fit-content',
	},
}));
export default useStyles;
